import { useContext, useEffect, useState } from "react";
import { Context } from "..";
import PositionsAPI from "../API/PositionsAPI";
import AssociacionsAPI from "../API/AssociationsAPI";

const showLogs = true;
const useAssociationsEditor = (associationName) => {

    const [dropbox, setDropbox] = useState(null);

    useEffect(() => {
        loadAssociations().then(() => showLogs && console.log("[✓] Список ответственных загружен"));
    }, []);

    const loadAssociations = async () => {
        try {
            let workers = await PositionsAPI.getAll();
            if (workers.status !== 200) throw workers;
            if (!workers.data || !workers.data.positionsWorker) throw workers;
            
            workers = workers.data.positionsWorker;

            let result = await AssociacionsAPI.getAll();
            if (result.status !== 200) throw result;
            if (!result.data) throw result;
            result = result.data;

            workers.unshift({ name: "Нет" });
            let index = 0;
            for (let i = 1; i < workers.length; i++) {
                if (workers[i].id !== result[associationName]) continue;
                index = i;
                break;
            }
            setDropbox({ values: [...workers], defaultValue: 0, currentValue: index, isOpened: false });
        } catch (err) {
            showLogs && console.log("[x] Ошибка загрузки списка ответственных:", err);
        }
    }

    const updateAssociation = async (newId) => {
        try {
            const response = await AssociacionsAPI.update({ [associationName]: newId });
            if (response.status !== 200) throw response;
            await loadAssociations();
        } catch (err) {
            showLogs && console.log("[x] Ошибка обновления ответственного:", err);
        }
    }

    return {
        associationsDropbox: dropbox,
        changeAssociation: (newId) => {
            updateAssociation(newId).then(() => showLogs && console.log("[✓] Сопоставление обновлено"));
        }
    }
}

export default useAssociationsEditor;